
export default {
    name: 'SvgRedTag',
};
